import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CheckCircleTwoTone, ExclamationCircleTwoTone, SyncOutlined } from '@ant-design/icons';
import cs from 'classnames';
import s from './UploadStatus.module.less';

const UploadStatus = ({ status, errorMessage }) => {
  const { t } = useTranslation('common');

  switch (status) {
    case null:
      return null;
    case 'uploading':
      return <SyncOutlined spin />;
    case 'done':
      return (
        <div className={s.statusNotification} data-testid="upload-done">
          <CheckCircleTwoTone style={{ marginRight: 7 }} twoToneColor="#52c41a" />
          {t('csvUploadSuccess')}
        </div>
      );
    case 'error':
      return (
        <div className={cs([s.error, s.statusNotification])}>
          <ExclamationCircleTwoTone style={{ marginRight: 7 }} twoToneColor="red" />
          {errorMessage || t('fileUploadFailure')}
        </div>
      );
    default:
      return status;
  }
};
UploadStatus.propTypes = { status: PropTypes.string, errorMessage: PropTypes.string };
UploadStatus.defaultProps = { status: null, errorMessage: null };
export default UploadStatus;
